import "./About.css";
import AboutUse from "./use/AboutUse";
import logo from "../../assets/logo.png";


export default function About() {
  return (
    <div>
      <div class="curveArea">
          <div class="curveSection">
            <div className="curve-divs">
              <div className="curveElement">
                <img src={logo} alt="logo" />
              </div>
              <div className="curveElement curveElement-margin">
                <h2 >Hey! We are</h2>
                <h1 >LoopGem</h1>
                <p>
                  We are here to propel the NFT creator economy. Artists, influencers, 
                  and collectors are the three main pillars of the LoopGem community. 
                </p>
              </div>
            </div>
          </div>
      </div>
      
      <h2 className="why-subheading">Why use LoopGem?</h2>
      <AboutUse />
      
      <h2 className="subheading">How does it work?</h2>
      <div className="component-list component-border">
        <p>
          <h3>1. Connect your wallet:</h3>
          <ul>
            <li>Start your journey on LoopGem by connecting your wallet. We currently support Metamask and Wallet Connect.</li>
          </ul>
        </p>
        <p>
          <h3>2. Create(mint) an NFT and List on LoopGem:</h3>
          <ul>
            <li>Click on the “Create” button on the top right corner of the home page. </li>
            <li>On the NFT creation page, upload your art. Add the required details and click on the “Create” button at the bottom of the NFT creation page  - name, description, price and blockchain. </li>
            <li>Approve wallet request to execute NFT smart contract. </li>
            <li>Approve wallet request to execute the LoopGem marketplace smart contract.</li>
            <li>Congrats, NFT is created(minted) and listed on the marketplace!! </li>
            <li>Note - No service fee for creating (minting) the NFT. Only network gas fees will be charged. 2.5% of the listed price will be charged as the service fee when the NFT is sold. </li>
            <li>Click on the avatar in the right corner and choose the profile option to view your NFTs. </li>
          </ul>
        </p>
        <p>
          <h3>3. Promote an NFT:</h3>
          <ul>
            <li>Click on the “promote” button on the NFT detail page to promote your NFT.</li>
            <li>Select the influencers of your choice and submit the budget for promotion. </li>
            <li>LoopGem will reach out to the influencers that you selected and request them to promote your NFT on their Twitter page. </li>
            <li>Once an influencer agrees, LoopGem will connect with you via email and request you to send crypto to the influencer's wallet. </li>
            <li>Once an influencer confirms that they received the promotional amount in their wallet, they will promote your NFT on their twitter account.  </li>
          </ul>
        </p>
        <p>
          <h3>4. Delist an NFT:</h3>
          <ul>
            <li>Click on the “Delist” button on the NFT detail page. </li>
            <li>Approve wallet request to delist an NFT</li>
            <li>Note - There is no service fee to delist an NFT, only network gas fees will be charged. </li>
          </ul>
        </p>
        <p>
          <h3>5. Buy an NFT:</h3>
          <ul>
            <li>Click on the “Buy Now” button on the NFT detail page. </li>
            <li>Approve wallet request to buy an NFT</li>
            <li>Congrats the NFT is bought and it can be viewed on the profile page.</li>
          </ul>
        </p>
        <p>
          <h3>6. Resell/Relist an NFT:</h3>
          <ul>
            <li>Click on the “List Now” button on the NFT detail page. </li>
            <li>Enter the selling price of the NFT and hit enter.</li>
            <li>Approve wallet request to resell/relist an NFT</li>
            <li>Congrats NFT is listed on LoopGem again and it is ready to be sold. </li>
          </ul>
        </p>
      </div>
    </div>
  );
}
